import 'array.prototype.tosorted/auto'
import 'array.prototype.toreversed/auto'

import './common/utils/stashUrlDeeplinks'

import { MODALS } from './common/types'
import type { WindowAppShell } from './common/types'
import {
  AppshellEventKeys,
  OrganizationActionKeys,
  AccountType,
} from './common/events/types'
import { ORGANIZATION_ACTIONS } from './common/events/orgEvents'
import { ORCHESTRATOR_ACTIONS } from './common/events/orchestratorEvents'
import { MODAL_ACTIONS } from './common/events/modalEvents'
import { ACCOUNT_ACTIONS } from './common/events/accountEvents'

import render from './exports/Navigator'

// Exports for use in other buffer-mono projects. Once all projects use the app-shell directly,
// we can remove the above imports and stop setting window.appshell here
export {
  MODALS,
  AppshellEventKeys,
  AccountType,
  OrganizationActionKeys,
  ORGANIZATION_ACTIONS,
  ORCHESTRATOR_ACTIONS,
  MODAL_ACTIONS,
  ACCOUNT_ACTIONS,
  WindowAppShell,
}

export { AppShell, ReduxWrappedNavigator } from './exports/Navigator'
export { HostNavigationProvider } from './common/hostNavigation/HostNavigationContext'
export type { HostNavigation } from './common/hostNavigation/HostNavigationContext'
export { default as Navigation } from './components/Navigation'

export * from './components/PlanSelector'
export * from './components/PlanOverrideConfirmationDialog'
export { SubscriptionUpdateModal } from './components/Modal/modals/SubscriptionUpdate'
export type { SubscriptionUpdate } from './components/Modal/modals/SubscriptionUpdate'
export { useStripePaymentConfirmation } from './hooks'

;(function init(): void {
  render()
})()
